import requestService from '../requestService';

export default {
    async getBusinessFromCategory(numberCategory) {
		const response = await requestService.get(`citypass/businesses/search?category=${numberCategory}`, {
			headers: { 'x-citypass-key': `${process.env.VUE_APP_X_API_KEY}` }
		})
		return response?.data
	},
}